const requiredFirebaseFields = {
  apiKey: "REACT_APP_FIREBASE_API_KEY",
  authDomain: "REACT_APP_FIREBASE_AUTH_DOMAIN",
  projectId: "REACT_APP_FIREBASE_PROJECT_ID",
  appId: "REACT_APP_FIREBASE_APP_ID",
};
const isFirebaseConfigReady = (config) =>
  Object.keys(requiredFirebaseFields).every(
    (key) => typeof config[key] === "string" && config[key].trim()
  );
const missingFirebaseVariables = (env) =>
  Object.values(requiredFirebaseFields).filter((key) => !String(env[key] || "").trim());
module.exports = { isFirebaseConfigReady, missingFirebaseVariables };
